export default __webpack_public_path__ + "static/media/unchecked.f2f72ca0.svg";